/**
 * Lightweight in-memory chat cache keyed by userId + teamId (+ sessionId for messages).
 * Invalidate on logout, team switch, new message, or session mutations.
 */

const sessionsCache = new Map();
const messagesCache = new Map();

export function sessionsListKey(userId, teamId) {
  return `${String(userId)}:${String(teamId)}:sessions`;
}

export function messagesThreadKey(userId, teamId, sessionId) {
  return `${String(userId)}:${String(teamId)}:${String(sessionId)}:messages`;
}

export function getCachedSessionsList(userId, teamId) {
  return sessionsCache.get(sessionsListKey(userId, teamId)) ?? null;
}

export function setCachedSessionsList(userId, teamId, data) {
  sessionsCache.set(sessionsListKey(userId, teamId), data);
}

export function getCachedMessages(userId, teamId, sessionId) {
  return messagesCache.get(messagesThreadKey(userId, teamId, sessionId)) ?? null;
}

export function setCachedMessages(userId, teamId, sessionId, data) {
  messagesCache.set(messagesThreadKey(userId, teamId, sessionId), data);
}

/** Invalidate sessions list for a workspace; optionally one message thread. */
export function invalidateChatCache(userId, teamId, sessionId = null) {
  if (userId == null || teamId == null) return;
  sessionsCache.delete(sessionsListKey(userId, teamId));
  if (sessionId != null) {
    messagesCache.delete(messagesThreadKey(userId, teamId, sessionId));
  }
}

/** Call on logout to avoid leaking prior user/team state. */
export function invalidateAllChatCache() {
  sessionsCache.clear();
  messagesCache.clear();
}
